export const TRANSLATIONS = {
  de: {
    // --- Admin Panel (General) ---
    adminTitle: 'Admin Dashboard',
    save: 'Speichern',
    saving: 'Speichere...',
    loading: 'Wird geladen...',
    upload: 'Hochladen',
    uploading: 'Wird hochgeladen...',
    deleteMedia: 'Alle Medien löschen',
    deleteMediaConfirmTitle: 'Alle Anhänge löschen',
    deleteMediaConfirmContent: 'Sind Sie sicher, dass Sie alle Anhänge löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    chatbotName: 'Name des Chatbots',
    language: 'Sprache',
    primaryColor: 'Primärfarbe',
    secondaryColor: 'Sekundärfarbe',
    fontFamily: 'Schriftart',
    logoUpload: 'Logo hochladen',
    preview: 'Vorschau',
    saveImpossible: 'Speichern nicht möglich',
    fieldRequired: 'Feld darf nicht leer sein',

    defaultWelcomeMessage: 'Hallo! Ich bin Ihr Assistent. Wie kann ich Ihnen heute helfen?',

    // --- Common actions ---
    cancel: 'Abbrechen',
    close: 'Schließen',
    back: 'Zurück',
    continue: 'Weiter',
    skip: 'Überspringen',
    finishNow: 'Jetzt abschließen',
    finishSetup: 'Setup abschließen',
    startChatting: 'Chat starten',
    reset: 'Zurücksetzen',
    copied: 'Kopiert',
    copiedToClipboard: 'In Zwischenablage kopiert.',
    copyFailed: 'Kopieren auf diesem Gerät nicht möglich.',
    pleaseLogin: 'Bitte anmelden.',
    pleaseLoginAgain: 'Bitte melden Sie sich erneut an.',

    // --- Toasts / Errors ---
    successSaved: 'Einstellungen erfolgreich gespeichert!',
    errorSaved: 'Fehler beim Speichern der Einstellungen.',
    successLogo: "Logo hochgeladen! Klicken Sie auf 'Speichern', um es zu übernehmen.",
    errorFileTooBig: 'Die Datei ist zu groß (Max 2MB).',
    errorInvalidFileType: 'Unerlaubter Dateityp. Bitte eine .zip Datei hochladen.',
    errorUploadInProgress: 'Ein Upload läuft bereits.',
    errorSelectValidFile: 'Bitte wählen Sie eine gültige Datei aus.',
    errorFixErrors: 'Bitte beheben Sie die Fehler vor dem Speichern.',
    errorUploadFailed: 'Fehler beim Hochladen der Daten.',
    errorMediaUploadFailed: 'Fehler beim Hochladen der Medien.',
    successUpload: 'Daten erfolgreich hochgeladen!',
    selectedFile: 'Ausgewählte Datei:',
    dropzoneText: 'Ziehen Sie eine .zip Datei hierher oder klicken Sie zum Auswählen',

    // --- Model Selection ---
    modelLabel: 'KI Modell',
    modelFast: 'Schnell (Flash Lite)',
    modelThinking: 'Intelligent (Pro)',
    modelUnknown: 'Unbekannt',
    modelUpdated: 'Modell aktualisiert auf:',
    errorLoadModel: 'Fehler beim Laden des Modell-Typs.',
    errorSaveModel: 'Fehler beim Speichern des Modells.',

    // --- Prompt Editing ---
    systemPromptTitle: 'System Prompt & Verhalten',
    updatePromptLabel: 'System Prompt bearbeiten',
    successPromptUpdate: 'System Prompt erfolgreich aktualisiert!',
    errorPromptUpdate: 'Fehler beim Aktualisieren des Prompts.',
    errorLoadPrompt: 'Fehler beim Laden des Prompts.',

    // --- Recent Prompts ---
    loadRecentPrompts: 'Verlauf laden',
    recentPromptsTitle: 'Letzte Prompts',
    loadDefaultPrompt: 'Standard wiederherstellen',
    promptFrom: 'Prompt vom',
    promptDisclaimer: 'Hier sehen Sie die letzten 10 gespeicherten Prompts. Wählen Sie einen aus, um ihn in das Editor-Feld zu laden.',
    loadThisPrompt: 'Diesen Prompt laden',

    // --- RAG / Knowledge Base ---
    knowledgeBaseTitle: 'Wissensdatenbank (RAG)',
    knowledgeBaseDesc: 'Laden Sie Dokumente (PDF, Word, Text) hoch, damit der Chatbot sie als Kontext verwenden kann.',
    knowledgeBaseSupported: 'Unterstützt: PDF, Word (.doc/.docx), Text (.txt/.md) und Bilder.',
    chooseFile: 'Datei auswählen',
    remove: 'Entfernen',
    analyzingAndSaving: 'Analysiere & speichere...',
    kbUnsupportedFileType: 'Dateityp nicht unterstützt. Erlaubt: PDF, Word, Text, Bilder.',
    kbUploadFailed: 'Upload fehlgeschlagen.',
    kbUploadRetry: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
    uploadDoc: 'Dokument hochladen',
    processing: 'Verarbeite...',

    // --- Zip Info Dialog ---
    zipInfoTitle: 'Informationen zur ZIP-Struktur',
    zipInfoDescription: 'Nutzen Sie diesen Bereich als strukturierte Anleitung vor dem Import von ZIP-Paketen, damit Uploads sauber und konsistent bleiben.',
    zipStructureTitle: 'Aufbau der .zip Datei',
    zipStructureAlt: 'Diagramm: Struktur einer ZIP-Datei',
    fileRulesTitle: 'Struktur-Regeln',
    drawioRulesTitle: 'Regeln der .drawio Datei',
    generalInfoTitle: 'Allgemeine Informationen',

    fileStructureRules: [
      'Der Name der Datei muss auf .zip enden.',
      'Die .drawio Datei muss auf .drawio enden.',
      'Es darf genau eine .drawio Datei enthalten sein.',
      'Bilder und Videos müssen in einem Ordner namens "media" oder "Media" liegen.',
      'Bilder werden über den Ordnernamen (z.B. "L123") mit den Knoten verknüpft.',
      'Erlaubte Dateitypen: .png, .jpg, .jpeg, .mp4.',
      'Dateinamen der Bilder sind frei wählbar.',
      'Optionale .txt Dateien für textlichen Inhalt möglich.',
    ],
    drawioFileRules: [
      'Alle Pfeile müssen eine Quelle und ein Ziel haben.',
      'Ein Prefix besteht aus einem Buchstaben gefolgt von Zahlen.',
      'Die Buchstaben sind "L", "F", "SUP" und "K".',
      'Texte ohne Prefix sind Fragen des Chatbots.',
      '"LXXX" sind Antworten des Chatbots (Lösungen).',
      '"KXXX" sind Einstiegspunkte (Kundenanliegen).',
      '"FXXX" sind Rückfragen (Follow-Up).',
      '"SUPXXX" sind Support-Weiterleitungen.',
    ],
    generalInformation: [
      'Der Chatbot gibt die Informationen genau so weiter, wie sie definiert sind.',
      'Farben spielen keine Rolle.',
      'Knoten sind Fragen/Antworten, Pfeile sind die Antworten des Nutzers.',
      'Erstellen Sie den Graphen am besten auf "https://draw.io" oder laden Sie die Desktop-App herunter.',
    ],

    // --- Draw.io Import ---
    drawioImportTitle: 'Draw.io Import (Entscheidungsbaum)',
    drawioImportDesc: 'Importieren Sie ein Draw.io ZIP-Paket, um Gesprächsflüsse zu strukturieren.',
    drawioImportNoteLabel: 'Hinweis:',
    drawioImportNoteText: 'Für normale PDF/Word-Dokumente nutzen Sie bitte oben die "Wissensdatenbank".',
    drawioZipOnly: 'Nur Draw.io ZIP',
    drawioTipLabel: 'Tipp:',
    drawioGenericZipTip: 'Wenn Sie versuchen, eine ZIP mit PDF/Word-Dokumenten hochzuladen, entpacken Sie sie bitte und laden Sie die Dateien einzeln in der "Wissensdatenbank" hoch.',

    // --- Chat Interface / Visual map ---
    showVisualMap: 'Visual Map anzeigen',
    hideVisualMap: 'Visual Map ausblenden',

    // --- Setup Wizard ---
    wizardStepTitleWelcome: 'Willkommen',
    wizardStepTitleName: 'Assistent benennen',
    wizardStepTitleLanguage: 'Sprache wählen',
    wizardStepTitleColors: 'Farben wählen',
    wizardStepTitleFont: 'Schriftart wählen',
    wizardStepTitleLogo: 'Logo hochladen',
    wizardStepTitleWallpaper: 'Chat-Hintergrund wählen',
    wizardStepTitleReview: 'Prüfen & abschließen',

    wizardIntroTag: 'Ersteinrichtung',
    wizardIntroHeadline: 'Machen Sie Ihren Chatbot zu Ihrem Produkt.',
    wizardIntroBody: 'Dieses Setup führt Sie durch dieselben Branding-Einstellungen wie im Admin-Bereich, aber in einem schnellen Erststart-Flow.',

    wizardNameHeadline: 'Chatbot-Namen wählen',
    wizardNameBody: 'Dieser Name erscheint im Chat-Header und in Export-Ansichten.',

    wizardLanguageHeadline: 'Hauptsprache auswählen',
    wizardLanguageBody: 'Diese Einstellung steuert die Standardsprache, die in Ihrer gespeicherten Konfiguration verwendet wird.',

    wizardColorsHeadline: 'Markenfarben wählen',
    wizardColorsBody: 'Diese Farben werden im Chat-Header, bei Buttons und in der Vorschau verwendet.',

    wizardFontHeadline: 'Schriftart auswählen',
    wizardFontBody: 'Wählen Sie eine Schrift, die zu Ihrer Marke passt und im gesamten Chat gut lesbar bleibt.',

    wizardLogoHeadline: 'Logo hochladen',
    wizardLogoBody: 'Optional – aber es lässt den Chat-Header deutlich professioneller wirken.',
    wizardLogoReady: 'Logo bereit',

    wizardWallpaperHeadline: 'Chat-Hintergrund auswählen',
    wizardWallpaperBody: 'Wählen Sie ein Hintergrund-Preset für den Chat-Bereich oder lassen Sie es schlicht.',

    wizardReviewHeadline: 'Setup prüfen',
    wizardReviewBody: 'Diese Werte werden gespeichert und später im Admin-Bereich erneut angezeigt. Dort können Sie sie jederzeit ändern.',

    wizardReviewName: 'Name:',
    wizardReviewLanguage: 'Sprache:',
    wizardReviewPrimary: 'Primär:',
    wizardReviewSecondary: 'Sekundär:',
    wizardReviewFont: 'Schrift:',
    wizardReviewLogo: 'Logo:',
    wizardReviewWallpaper: 'Hintergrund:',

    wizardProgress: 'Schritt {current} von {total}',
    wizardLeftTitle: 'Geführtes Branding-Setup',
    wizardLeftBody: 'Wählen Sie Branding-Details, überspringen Sie, was Sie nicht brauchen, und schließen Sie das Setup in wenigen Schritten ab.',
    wizardLeftDoneTitle: 'Setup abgeschlossen',
    wizardLeftDoneBody: 'Alles ist gespeichert und bereit.',

    wizardPreviewSubtitle: 'Branding-fertiger Assistent',
    wizardPreviewMessage: 'Hallo! Ich nutze nach dem Setup Ihre Farben, Schriftart, Hintergrund und Ihr Branding.',

    wizardDoneHeadline: 'Alles fertig',
    wizardDoneBody: 'Ihr Setup ist gespeichert. Sie können jetzt den Chat starten.',

    // --- Wallpapers ---
    wallpaper1Label: 'Wallpaper 1',
    wallpaper1Desc: 'Sanftes Blau',
    wallpaper2Label: 'Wallpaper 2',
    wallpaper2Desc: 'Frisches Grün',
    wallpaper3Label: 'Wallpaper 3',
    wallpaper3Desc: 'Violettes Leuchten',
    wallpaperNoneLabel: 'Kein Hintergrund',
    wallpaperNoneDesc: 'Schlicht',

    // --- Admin Page Header ---
    adminBadgePremium: 'Premium Admin',
    adminHeaderTitle: 'Admin Dashboard',
    adminHeaderDescription: 'Branding, Prompts, Wissensquellen und Medien in einem übersichtlichen Arbeitsbereich verwalten – mit klarer Scope-Steuerung und sicheren Aktionen.',
    adminHeaderTenantNotSelected: 'Tenant: nicht ausgewählt',
    adminHeaderChatbotNotSelected: 'Chatbot: nicht ausgewählt',
    adminHeaderScopeWarning: 'Destruktive Aktionen laufen immer im aktuell ausgewählten Tenant- und Chatbot-Scope.',
    adminDeleteDialogHeader: 'Alle Medien löschen',
    adminDeleteDialogNoBot: 'Bitte wählen Sie zuerst einen aktiven Chatbot aus.',
    adminDeleteDialogScopedIntro: 'Sind Sie sicher, dass Sie alle Anhänge für den aktiven Chatbot löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    adminDeleteSuccessCount: '{count} Medienanhänge wurden erfolgreich gelöscht.',
    adminDeleteSuccessNone: 'Es waren keine Medienanhänge zum Löschen vorhanden.',
    adminDeleteFailed: 'Fehler beim Löschen der Anhänge: {message}',
    adminSelectActiveChatbotFirst: 'Bitte wählen Sie zuerst einen aktiven Chatbot aus.',
    adminDeleteButtonSelectChatbot: 'Chatbot auswählen',

    // --- Admin Interface (Tenant/Bot management) ---
    adminCreateNewChatbotTitle: 'Neuen Chatbot erstellen',
    adminCreateNewChatbotBody: 'Geben Sie einen klaren internen Namen an. Sie können ihn nach der Erstellung jederzeit umbenennen.',
    adminCreateNewChatbotNameLabel: 'Chatbot-Name',
    adminCreateNewChatbotPlaceholder: 'z.B. Support-Assistent',
    adminCreateNewChatbotHelperDefault: 'Wählen Sie einen kurzen, gut erkennbaren Namen.',
    adminCreateNewChatbotHelperDuplicate: 'Ein Chatbot mit diesem Namen existiert bereits in diesem Tenant.',
    adminCreateChatbot: 'Chatbot erstellen',
    adminCreatingChatbot: 'Erstelle...',

    adminActiveChatbotSectionTitle: 'Aktiver Chatbot',
    adminTenantLabel: 'Tenant',
    adminChatbotLabel: 'Chatbot',
    adminNoTenantAvailable: 'Kein Tenant verfügbar',
    adminNoChatbotsAvailable: 'Keine Chatbots verfügbar',

    adminBotActive: 'Bot aktiv',
    adminBotPaused: 'Bot pausiert',
    adminPublicWidgetLive: 'Öffentlich live',
    adminPrivateDraft: 'Privater Entwurf',
    adminAllowedDomainsCount: '{count} erlaubte {item}',
    adminAllowedDomainSingular: 'Domain',
    adminAllowedDomainPlural: 'Domains',
    adminPublicBotId: 'Public Bot-ID',

    adminAllowedDomainsLabel: 'Erlaubte Domains',

    adminNewChatbotButton: 'Neuer Chatbot',
    adminPlanLimitReached: 'Chatbot-Limit für diesen Plan erreicht.',

    adminNoActiveChatbotAlert: 'Erstellen Sie Ihren ersten Chatbot oder wählen Sie einen aus der Liste, um Konfiguration, Prompts und Wissensverwaltung freizuschalten.',

    adminChatbotNameHelperInternal: 'Interner Name im Admin-Bereich.',
    adminAllowedDomainsHelper: 'Eine Domain pro Zeile oder durch Kommas getrennt. Aktuell erlaubt: {count} {item}.',

    adminPublicWidgetPublished: 'Öffentliches Widget veröffentlicht',

    adminSaveBotSettings: 'Bot-Einstellungen speichern',
    adminSaved: 'Gespeichert',

    adminClientIntegration: 'Integration',
    adminClientIntegrationInfo: 'Sie können diesen Bot auf Ihrer eigenen Website veröffentlichen. Nutzen Sie das Skript für ein schwebendes Widget, das iFrame für einen eingebetteten Vollchat oder den Direktlink für eine gehostete Standalone-Chatseite.',
    adminWidgetScriptSnippet: 'Widget-Skript-Snippet',
    adminIframeSnippet: 'iFrame-Snippet',
    adminHostedDirectLink: 'Gehosteter Direktlink',
    adminCopyWidgetScript: 'Widget-Skript kopieren',
    adminCopyIframeSnippet: 'iFrame kopieren',
    adminCopyDirectLink: 'Direktlink kopieren',
    adminAllowedDomainsEnforced: 'Erlaubte Domains werden bei Widget- und iFrame-Embeds erzwungen. Der Direktlink ist eine eigenständige öffentliche Seite für diesen veröffentlichten Bot.',

    adminUnsavedSettingsAlert: 'Sie haben ungespeicherte Bot-Einstellungen. Bitte speichern oder zurücksetzen, bevor Sie wechseln.',

    adminErrorLoadTenantChatbots: 'Tenant-Chatbots konnten nicht geladen werden.',
    adminErrorCopyClipboard: 'Kopieren auf diesem Gerät nicht möglich.',
    adminErrorEnterName: 'Bitte geben Sie vor dem Erstellen einen Chatbot-Namen ein.',
    adminErrorNameExistsInTenant: 'Ein Chatbot mit diesem Namen existiert bereits im ausgewählten Tenant.',
    adminSuccessCreated: 'Neuer Chatbot erstellt. Domains konfigurieren und anschließend veröffentlichen.',
    adminErrorCreateFailed: 'Neuer Chatbot konnte nicht erstellt werden.',
    adminSuccessReset: 'Änderungen auf die zuletzt gespeicherten Bot-Einstellungen zurückgesetzt.',
    adminErrorNameEmpty: 'Chatbot-Name darf nicht leer sein.',
    adminErrorNameDuplicate: 'Ein anderer Chatbot in diesem Tenant nutzt bereits diesen Namen.',
    adminErrorNeedDomainToPublish: 'Fügen Sie mindestens eine erlaubte Domain hinzu, bevor Sie den Bot veröffentlichen.',
    adminSuccessBotSettingsSaved: 'Chatbot-Einstellungen erfolgreich gespeichert.',
    adminErrorBotSettingsSaveFailed: 'Chatbot-Einstellungen konnten nicht gespeichert werden.',

    adminCopiedEmbed: 'Widget-Skript in Zwischenablage kopiert.',
    adminCopiedIframe: 'iFrame-Snippet in Zwischenablage kopiert.',
    adminCopiedDirectLink: 'Direktlink in Zwischenablage kopiert.',
    adminCopiedGeneric: 'In Zwischenablage kopiert.',

    adminCopyTooltipCopied: 'Kopiert',

    // --- Chat UI (Header / Input / Messages) ---
    defaultChatbotName: 'Assistent',
    youLabel: 'Sie',
    userLabel: 'User',
    thinkingEllipsis: 'Denkt nach…',
    chatHeaderReady: 'Smarter Assistent • bereit zu helfen',
    chatHeaderSavePdf: 'Als PDF speichern',
    chatHeaderOpenAdmin: 'Admin-Bereich öffnen',
    chatHeaderCopyChat: 'Chat kopieren',
    chatHeaderNewChat: 'Neuen Chat starten',
    chatHeaderPdfDownloaded: 'PDF erfolgreich heruntergeladen.',
    chatHeaderPdfCreateFailed: 'PDF konnte nicht erstellt werden.',
    chatHeaderAvatarAlt: 'Chatbot-Avatar',

    imagePreviewTitle: 'Bildansicht',
    imagePreviewAlt: 'Vorschau des Chat-Anhangs',

    chatInputRemoveImage: 'Ausgewähltes Bild entfernen',
    chatInputUploadImage: 'Bild hochladen',
    chatInputListeningPlaceholder: 'Zuhören in {lang}… jetzt sprechen',
    chatInputTypePlaceholder: 'Nachricht schreiben…  •  Enter zum Senden',
    chatInputMessageInputAria: 'Nachrichteneingabe',
    chatInputStopVoice: 'Spracheingabe stoppen',
    chatInputStartVoice: 'Spracheingabe starten ({lang})',
    chatInputStartVoiceAria: 'Spracheingabe in {lang} starten',
    chatInputSend: 'Nachricht senden',
    chatInputMicDenied: 'Mikrofonzugriff wurde verweigert. Bitte prüfen Sie Ihre Browser-Einstellungen.',
    chatInputVoiceError: 'Spracheingabe-Fehler: {error}',
    chatInputSpeechNotSupported: 'Ihr Browser unterstützt keine Spracherkennung.',
    chatInputImageTypeUnsupported: 'Nur JPG, PNG und WEBP werden unterstützt.',
    chatInputImageTooLarge: 'Das Bild ist zu groß. Bitte unter 5 MB bleiben.',

    sourcesSingular: 'Quelle',
    sourcesPlural: 'Quellen',
    referencedDocuments: 'Referenzierte Dokumente',
    relevanceMatch: 'Relevanz',

    smartStarterTitle: 'Vorschläge zum Starten:',
    smartStarterFixLabel: 'Fehler beheben',
    smartStarterFixText: 'Ich habe ein Problem mit einer Maschine.',
    smartStarterMaintenanceLabel: 'Wartung',
    smartStarterMaintenanceText: 'Wie führe ich die Wartung durch?',
    smartStarterSupportLabel: 'Support Kontakt',
    smartStarterSupportText: 'Ich möchte den Support kontaktieren.',
    smartStarterHelpLabel: 'Hilfe',
    smartStarterHelpText: 'Was kannst du tun?',

    processVisualizerTitle: 'Prozess-Visualizer',
    processVisualizerSubtitle: 'Live-Ansicht Ihres Chatbot-Flows und verbundener Knoten',
    noProcessData: 'Keine Prozessdaten verfügbar.',

    chatTranscriptTitle: '{name} Chat-Protokoll',
    exportedAt: 'Exportiert: {date}',
    copyFailedWithReason: 'Kopieren fehlgeschlagen: {error}',

    imageUploadLabel: 'Bild-Upload',

    // --- Parsing / ZIP validation ---
    zipNoFileSelected: 'Keine Datei ausgewählt.',
    zipNotZipFile: 'Die Datei ist keine ZIP-Datei.',
    zipInvalidFile: 'Datei ist fehlerhaft: {error}',
    zipDuplicateTextDefinition: 'Doppelte Text Definition gefunden für: {id}',
    zipMoreThanOneSup0Definition: 'Mehr als eine Text Definition für den SUP0-Knoten gefunden.',
    zipInvalidFilePath: 'Ungültiger Dateipfad: {path}',
    zipNoValidFileType: 'Datei "{file}" hat keinen gültigen Dateityp.',

    drawioXmlParserError: 'Drawio-Datei fehlerhaft: XML Parser Error',
    drawioRootNotFound: 'Drawio-Datei fehlerhaft: mxGraphModel/root nicht gefunden',
    drawioMalformed: 'Drawio-Datei fehlerhaft: {error}',
    drawioStartQuestionCount: 'Es muss genau 1 Startfrage geben, gefunden: {count}',
    drawioQuestionNoAnswerPaths: 'Frage "{id}" hat keine Antwort-Pfade.',
    drawioAnswerCellNotFound: 'Antwortzelle nicht gefunden für Frage "{id}".',
    drawioAnswerLeadsNowhere: 'Antwort "{answer}" von Frage "{id}" führt nirgendwo hin.',
    drawioAnswerMultipleExits: 'Antwort "{answer}" von Frage "{id}" hat mehrere Ausgänge (mehrdeutig).',
    drawioAnswerInvalidTarget: 'Antwort "{answer}" von Frage "{id}" führt zu keinem gültigen Ziel.',
    drawioPromptNoConnectives: 'Prompt "{id}" hat keine Connective-Pfade.',
    drawioConnectiveNoTarget: 'Connective "{text}" hat kein Ziel.',
    drawioConnectiveTargetNotFound: 'Connective-Ziel nicht gefunden für "{text}".',
    drawioConnectiveMustLead: 'Connective "{text}" muss zu Frage oder Prompt führen.',

    saved: 'Gespeichert',
    languageOptionGerman: 'Deutsch',
    languageOptionEnglish: 'Englisch',
    promptLabel: 'Prompt',
    previewLogoAlt: 'Chatbot-Logo',
    previewBotAlt: 'Bot-Vorschau',
    livePreview: 'Live-Vorschau',
    previewAssistantStyle: 'Premium-Assistentenstil',
    previewAssistantMessage: 'Hallo! Ich bin bereit, mit einer aufgeräumteren und hochwertigeren Gesprächserfahrung zu helfen.',
    activePalette: 'Aktive Farbpalette',
    wallpaperLabel: 'Hintergrund',
    wallpaperSectionTitle: 'Chat-Hintergrund',
    wallpaperSectionDescription: 'Wählen Sie eines der festen Presets für den Chat-Bereich.',
    authRequiredAgain: 'Sie sind noch nicht angemeldet. Bitte melden Sie sich erneut an.',
    errorUploadGeneric: 'Fehler beim Hochladen.',
    drawioClearSuccess: 'Draw.io-Datenbank erfolgreich gelöscht.',
    drawioClearFailed: 'Datenbank konnte nicht gelöscht werden.',
    drawioClearError: 'Fehler beim Löschen der Datenbank.',
    drawioMissingUploadContext: 'Fehlender Chatbot-Kontext für den Upload.',
    drawioCurrentDatabaseTitle: 'Aktuelle Draw.io-Datenbank',
    drawioCurrentDatabaseCount: '{count} Knoten sind aktuell indexiert.',
    clearAll: 'Alles löschen',
    clearing: 'Wird gelöscht...',
    drawioValidationFailed: 'Validierung fehlgeschlagen. Bitte beheben Sie die Fehler unten.',
    drawioWarningTitle: 'Draw.io-Hinweis',
    drawioWarningBody: 'Die ZIP-Datei kann trotzdem hochgeladen werden. In diesem Fall werden Medien- und Textdateien gespeichert, während die ungültige Draw.io-Struktur übersprungen wird.',
    kbDeleteSuccess: 'Dokument entfernt.',
    kbDeleteFailed: 'Dokument konnte nicht entfernt werden.',
    kbStoredDocumentsTitle: 'Gespeicherte Dokumente',
    kbStoredDocumentsDescription: 'Übersicht aller aktuell für diesen Chatbot gespeicherten Dateien der Wissensdatenbank.',
    refresh: 'Aktualisieren',
    refreshing: 'Aktualisiere…',
    kbLoadingDocuments: 'Gespeicherte Dokumente werden geladen…',
    kbNoDocuments: 'Es sind noch keine Dokumente gespeichert. Laden Sie oben eine Datei hoch, um sie zur Wissensdatenbank hinzuzufügen.',
    kbUnnamedDocument: 'Unbenanntes Dokument',
    kbUnknownType: 'Unbekannter Typ',
    kbChunkCount: '{count} Chunks',
    kbUpdatedAt: 'Aktualisiert {date}',
    kbStatusReady: 'Bereit',
    kbStatusProcessing: 'Wird verarbeitet',
    kbStatusFailed: 'Fehlgeschlagen',
    kbStatusUnknown: 'Unbekannt',
    systemPromptDescription: 'Steuern Sie Verhalten, Ton und Systemlogik des Assistenten in einem übersichtlicheren Editor mit ausgewogenerer Breite.',
    promptStatusUnsaved: 'Sie haben ungespeicherte Prompt-Änderungen für diesen Chatbot.',
    promptStatusSaved: 'Der zuletzt gespeicherte Prompt ist bereits für diesen Chatbot geladen.',
    noSavedPromptHistory: 'Für diesen Chatbot wurde noch kein gespeicherter Prompt-Verlauf gefunden.',
    modelUpdatedTo: 'Modell aktualisiert auf: {model}',
    adminErrorNoChatbotReturnedCreate: 'Es wurde kein Chatbot aus dem Erstellen-Vorgang zurückgegeben.',
    adminErrorNoChatbotReturnedUpdate: 'Es wurde kein Chatbot aus dem Aktualisieren-Vorgang zurückgegeben.',
    customizationStatusUnsaved: 'Sie haben ungespeicherte Anpassungen. Speichern Sie sie, um den neuen Stil auf diesen Chatbot anzuwenden.',
    customizationStatusSaved: 'Aktuell gibt es keine ungespeicherten Anpassungen.',

  },

  en: {
    // --- Admin Panel (General) ---
    adminTitle: 'Admin Dashboard',
    save: 'Save',
    saving: 'Saving...',
    loading: 'Loading...',
    upload: 'Upload',
    uploading: 'Uploading...',
    deleteMedia: 'Delete all media',
    deleteMediaConfirmTitle: 'Delete all attachments',
    deleteMediaConfirmContent: 'Are you sure you want to delete all attachments? This cannot be undone.',
    chatbotName: 'Chatbot Name',
    language: 'Language',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    fontFamily: 'Font Family',
    logoUpload: 'Upload Logo',
    preview: 'Preview',
    saveImpossible: 'Cannot save',
    fieldRequired: 'Field is required',

    defaultWelcomeMessage: 'Hello! I am your assistant. How can I help you today?',

    // --- Common actions ---
    cancel: 'Cancel',
    close: 'Close',
    back: 'Back',
    continue: 'Continue',
    skip: 'Skip',
    finishNow: 'Finish now',
    finishSetup: 'Finish setup',
    startChatting: 'Start chatting',
    reset: 'Reset',
    copied: 'Copied',
    copiedToClipboard: 'Copied to clipboard.',
    copyFailed: 'Could not copy to clipboard on this device.',
    pleaseLogin: 'Please log in.',
    pleaseLoginAgain: 'Please log in again.',

    // --- Toasts / Errors ---
    successSaved: 'Settings saved successfully!',
    errorSaved: 'Error saving settings.',
    successLogo: "Logo uploaded! Click 'Save' to apply.",
    errorFileTooBig: 'File is too big (Max 2MB).',
    errorInvalidFileType: 'Invalid file type. Please upload a .zip file.',
    errorUploadInProgress: 'Upload already in progress.',
    errorSelectValidFile: 'Please select a valid file.',
    errorFixErrors: 'Please fix errors before saving.',
    errorUploadFailed: 'Failed to upload data.',
    errorMediaUploadFailed: 'Failed to upload media.',
    successUpload: 'Data uploaded successfully!',
    selectedFile: 'Selected file:',
    dropzoneText: "Drag 'n' drop a .zip file here, or click to select",

    // --- Model Selection ---
    modelLabel: 'AI Model',
    modelFast: 'Fast (Flash Lite)',
    modelThinking: 'Smart (Pro)',
    modelUnknown: 'Unknown',
    modelUpdated: 'Model updated to:',
    errorLoadModel: 'Error loading model type.',
    errorSaveModel: 'Error saving model.',

    // --- Prompt Editing ---
    systemPromptTitle: 'System Prompt & Behavior',
    updatePromptLabel: 'Edit System Prompt',
    successPromptUpdate: 'System prompt updated successfully!',
    errorPromptUpdate: 'Error updating prompt.',
    errorLoadPrompt: 'Error loading prompt.',

    // --- Recent Prompts ---
    loadRecentPrompts: 'Load history',
    recentPromptsTitle: 'Recent Prompts',
    loadDefaultPrompt: 'Restore default',
    promptFrom: 'Prompt from',
    promptDisclaimer: 'Here are the last 10 saved prompts. Select one to load it into the editor.',
    loadThisPrompt: 'Load this prompt',

    // --- RAG / Knowledge Base ---
    knowledgeBaseTitle: 'Knowledge Base (RAG)',
    knowledgeBaseDesc: 'Upload documents (PDF, Word, Text) to provide context for the chatbot.',
    knowledgeBaseSupported: 'Supported: PDF, Word (.doc/.docx), Text (.txt/.md), and images.',
    chooseFile: 'Choose file',
    remove: 'Remove',
    analyzingAndSaving: 'Analyzing & saving...',
    kbUnsupportedFileType: 'Unsupported file type. Allowed: PDF, Word, text, images.',
    kbUploadFailed: 'Upload failed.',
    kbUploadRetry: 'Upload failed. Please try again.',
    uploadDoc: 'Upload Document',
    processing: 'Processing...',

    // --- Zip Info Dialog ---
    zipInfoTitle: 'ZIP Structure Information',
    zipInfoDescription: 'Use this section as a structured guide before importing ZIP packages, so uploads stay clean and consistent.',
    zipStructureTitle: 'Structure of the .zip file',
    zipStructureAlt: 'Diagram showing the structure of a ZIP file',
    fileRulesTitle: 'Structure Rules',
    drawioRulesTitle: 'Rules for .drawio file',
    generalInfoTitle: 'General Information',

    fileStructureRules: [
      'File name must end with .zip.',
      'The .drawio file must end with .drawio.',
      'Only one .drawio file is allowed.',
      'Images/Videos must be in a folder named "media" or "Media".',
      'Images are linked to nodes via folder name (e.g., "L123").',
      'Allowed types: .png, .jpg, .jpeg, .mp4.',
      'Image filenames can be anything.',
      'Optional .txt files for text content.',
    ],
    drawioFileRules: [
      'All arrows must have a source and a target.',
      'A prefix consists of a letter followed by numbers.',
      'Letters are "L", "F", "SUP" and "K".',
      'Texts without prefix are bot questions.',
      '"LXXX" are bot answers (solutions).',
      '"KXXX" are entry points (customer issues).',
      '"FXXX" are follow-up questions.',
      '"SUPXXX" are support redirects.',
    ],
    generalInformation: [
      'The chatbot relays information exactly as defined.',
      'Colors are ignored.',
      'Nodes are questions/answers, arrows are user answers.',
      'Create the graph on "https://draw.io" or download the desktop app.',
    ],

    // --- Draw.io Import ---
    drawioImportTitle: 'Draw.io Import (Decision Tree)',
    drawioImportDesc: 'Import a specific Draw.io ZIP package to structure conversation flows.',
    drawioImportNoteLabel: 'Note:',
    drawioImportNoteText: 'For regular PDF/Word documents, use the "Knowledge Base" panel above.',
    drawioZipOnly: 'Draw.io ZIP only',
    drawioTipLabel: 'Tip:',
    drawioGenericZipTip: 'If you are trying to upload a ZIP of PDF/Word documents, please unzip them and upload them individually in the "Knowledge Base" panel.',

    // --- Chat UI (Header / Input / Messages) ---
    defaultChatbotName: 'Assistant',
    youLabel: 'You',
    userLabel: 'User',
    thinkingEllipsis: 'Thinking…',
    chatHeaderReady: 'Smart assistant • ready to help',
    chatHeaderSavePdf: 'Save as PDF',
    chatHeaderOpenAdmin: 'Open admin area',
    chatHeaderCopyChat: 'Copy chat',
    chatHeaderNewChat: 'Start new chat',
    chatHeaderPdfDownloaded: 'PDF downloaded successfully.',
    chatHeaderPdfCreateFailed: 'Could not create PDF.',
    chatHeaderAvatarAlt: 'Chatbot avatar',

    imagePreviewTitle: 'Image preview',
    imagePreviewAlt: 'Preview of chat attachment',

    chatInputRemoveImage: 'Remove selected image',
    chatInputUploadImage: 'Upload image',
    chatInputListeningPlaceholder: 'Listening in {lang}… speak now',
    chatInputTypePlaceholder: 'Write a message…  •  Press Enter to send',
    chatInputMessageInputAria: 'Message input',
    chatInputStopVoice: 'Stop voice input',
    chatInputStartVoice: 'Start voice input ({lang})',
    chatInputStartVoiceAria: 'Start voice input in {lang}',
    chatInputSend: 'Send message',
    chatInputMicDenied: 'Microphone access was denied. Please check your browser settings.',
    chatInputVoiceError: 'Voice input error: {error}',
    chatInputSpeechNotSupported: 'Your browser does not support speech recognition.',
    chatInputImageTypeUnsupported: 'Only JPG, PNG, and WEBP are supported.',
    chatInputImageTooLarge: 'The image is too large. Please stay under 5 MB.',

    sourcesSingular: 'Source',
    sourcesPlural: 'Sources',
    referencedDocuments: 'Referenced documents',
    relevanceMatch: 'Relevance',

    smartStarterTitle: 'Start with a suggestion:',
    smartStarterFixLabel: 'Fix issue',
    smartStarterFixText: 'I have a problem with a machine.',
    smartStarterMaintenanceLabel: 'Maintenance',
    smartStarterMaintenanceText: 'How do I carry out the maintenance?',
    smartStarterSupportLabel: 'Contact support',
    smartStarterSupportText: 'I want to contact support.',
    smartStarterHelpLabel: 'Help',
    smartStarterHelpText: 'What can you do?',

    processVisualizerTitle: 'Process visualizer',
    processVisualizerSubtitle: 'Live view of your chatbot flow and connected nodes',
    noProcessData: 'No process data available.',

    chatTranscriptTitle: '{name} chat transcript',
    exportedAt: 'Exported: {date}',
    copyFailedWithReason: 'Copy failed: {error}',

    imageUploadLabel: 'Image upload',

    // --- Chat Interface / Visual map ---
    showVisualMap: 'Show visual map',
    hideVisualMap: 'Hide visual map',

    // --- Setup Wizard ---
    wizardStepTitleWelcome: 'Welcome',
    wizardStepTitleName: 'Name your assistant',
    wizardStepTitleLanguage: 'Pick a language',
    wizardStepTitleColors: 'Choose your colors',
    wizardStepTitleFont: 'Select a font',
    wizardStepTitleLogo: 'Upload a logo',
    wizardStepTitleWallpaper: 'Pick a chat wallpaper',
    wizardStepTitleReview: 'Review & finish',

    wizardIntroTag: 'First-time setup',
    wizardIntroHeadline: 'Make your chatbot feel like your own product.',
    wizardIntroBody: 'This setup guides new users through the same branding controls available in the admin panel, but with a cleaner first-run experience.',

    wizardNameHeadline: 'Choose a chatbot name',
    wizardNameBody: 'This name appears in the chat header and export screens.',

    wizardLanguageHeadline: 'Select the main language',
    wizardLanguageBody: 'This controls the default chatbot language shown in your saved configuration.',

    wizardColorsHeadline: 'Choose your brand colors',
    wizardColorsBody: 'These colors are used in the chatbot header, buttons, and setup preview.',

    wizardFontHeadline: 'Select a font style',
    wizardFontBody: 'Choose a font that feels on-brand and stays readable across the whole chat UI.',

    wizardLogoHeadline: 'Upload a logo',
    wizardLogoBody: 'Optional, but it makes the chat header feel more polished and branded.',
    wizardLogoReady: 'Logo ready',

    wizardWallpaperHeadline: 'Pick a chat wallpaper',
    wizardWallpaperBody: 'Choose one fixed wallpaper preset for the chat area, or keep it plain.',

    wizardReviewHeadline: 'Review your setup',
    wizardReviewBody: 'These values will be saved and shown again inside the admin page, where they can be edited later.',

    wizardReviewName: 'Name:',
    wizardReviewLanguage: 'Language:',
    wizardReviewPrimary: 'Primary:',
    wizardReviewSecondary: 'Secondary:',
    wizardReviewFont: 'Font:',
    wizardReviewLogo: 'Logo:',
    wizardReviewWallpaper: 'Wallpaper:',

    wizardProgress: 'Step {current} of {total}',
    wizardLeftTitle: 'Guided branding setup',
    wizardLeftBody: 'Pick your preferred branding details, skip what you do not need, and finish in a few steps.',
    wizardLeftDoneTitle: 'Setup completed',
    wizardLeftDoneBody: 'Everything is saved and ready.',

    wizardPreviewSubtitle: 'Ready-to-brand assistant',
    wizardPreviewMessage: 'Hello! I will use your selected colors, font, wallpaper, and branding after setup is complete.',

    wizardDoneHeadline: 'You are all set',
    wizardDoneBody: 'Your setup is saved. Ready to start the chat.',

    // --- Wallpapers ---
    wallpaper1Label: 'Wallpaper 1',
    wallpaper1Desc: 'Soft blue mesh',
    wallpaper2Label: 'Wallpaper 2',
    wallpaper2Desc: 'Fresh green glow',
    wallpaper3Label: 'Wallpaper 3',
    wallpaper3Desc: 'Purple neon blend',
    wallpaperNoneLabel: 'None',
    wallpaperNoneDesc: 'Plain background',

    // --- Admin Page Header ---
    adminBadgePremium: 'Premium Admin',
    adminHeaderTitle: 'Admin Dashboard',
    adminHeaderDescription: 'Manage branding, prompts, knowledge sources, and media in one clean workspace with clearer scope controls and safer actions.',
    adminHeaderTenantNotSelected: 'Tenant: not selected',
    adminHeaderChatbotNotSelected: 'Chatbot: not selected',
    adminHeaderScopeWarning: 'Destructive actions always run inside the currently selected tenant and chatbot scope.',
    adminDeleteDialogHeader: 'Delete all media',
    adminDeleteDialogNoBot: 'Please select an active chatbot first.',
    adminDeleteDialogScopedIntro: 'Are you sure you want to delete all attachments for the active chatbot? This cannot be undone.',
    adminDeleteSuccessCount: '{count} media attachments deleted successfully.',
    adminDeleteSuccessNone: 'There were no media attachments to delete.',
    adminDeleteFailed: 'Failed to delete attachments: {message}',
    adminSelectActiveChatbotFirst: 'Please select an active chatbot first.',
    adminDeleteButtonSelectChatbot: 'Select a chatbot',

    // --- Admin Interface (Tenant/Bot management) ---
    adminCreateNewChatbotTitle: 'Create new chatbot',
    adminCreateNewChatbotBody: 'Add a clear internal name for this chatbot. You can rename it later after creation.',
    adminCreateNewChatbotNameLabel: 'Chatbot name',
    adminCreateNewChatbotPlaceholder: 'e.g. Support Assistant',
    adminCreateNewChatbotHelperDefault: 'Choose a short and recognizable name.',
    adminCreateNewChatbotHelperDuplicate: 'A chatbot with this name already exists in this tenant.',
    adminCreateChatbot: 'Create chatbot',
    adminCreatingChatbot: 'Creating...',

    adminActiveChatbotSectionTitle: 'Active chatbot',
    adminTenantLabel: 'Tenant',
    adminChatbotLabel: 'Chatbot',
    adminNoTenantAvailable: 'No tenant available',
    adminNoChatbotsAvailable: 'No chatbots available',

    adminBotActive: 'Bot active',
    adminBotPaused: 'Bot paused',
    adminPublicWidgetLive: 'Public widget live',
    adminPrivateDraft: 'Private draft',
    adminAllowedDomainsCount: '{count} allowed {item}',
    adminAllowedDomainSingular: 'domain',
    adminAllowedDomainPlural: 'domains',
    adminPublicBotId: 'Public bot ID',

    adminAllowedDomainsLabel: 'Allowed domains',

    adminNewChatbotButton: 'New chatbot',
    adminPlanLimitReached: 'Chatbot limit reached for this plan.',

    adminNoActiveChatbotAlert: 'Create your first chatbot or select one from the list to unlock configuration, prompts, and knowledge management.',

    adminChatbotNameHelperInternal: 'Internal name shown in the admin area.',
    adminAllowedDomainsHelper: 'One domain per line or separated by commas. {count} {item} currently allowed.',

    adminPublicWidgetPublished: 'Public widget published',

    adminSaveBotSettings: 'Save bot settings',
    adminSaved: 'Saved',

    adminClientIntegration: 'Client integration',
    adminClientIntegrationInfo: 'You can publish this bot on your own website. Use the script snippet for a floating widget, the iFrame for an embedded full chat area, or the direct link for a hosted standalone chat page.',
    adminWidgetScriptSnippet: 'Widget script snippet',
    adminIframeSnippet: 'iFrame snippet',
    adminHostedDirectLink: 'Hosted direct link',
    adminCopyWidgetScript: 'Copy widget script',
    adminCopyIframeSnippet: 'Copy iFrame snippet',
    adminCopyDirectLink: 'Copy direct link',
    adminAllowedDomainsEnforced: 'Allowed domains are enforced for widget and iFrame embeds. The hosted direct link is a standalone public page for this published bot.',

    adminUnsavedSettingsAlert: 'You have unsaved chatbot settings. Save or reset before switching away.',

    adminErrorLoadTenantChatbots: 'Could not load your tenant chatbots.',
    adminErrorCopyClipboard: 'Could not copy to clipboard on this device.',
    adminErrorEnterName: 'Please enter a chatbot name before creating it.',
    adminErrorNameExistsInTenant: 'A chatbot with this name already exists in the selected tenant.',
    adminSuccessCreated: 'New chatbot created. Configure domains, then publish it.',
    adminErrorCreateFailed: 'Could not create a new chatbot.',
    adminSuccessReset: 'Changes reverted to the last saved chatbot settings.',
    adminErrorNameEmpty: 'Chatbot name cannot be empty.',
    adminErrorNameDuplicate: 'Another chatbot in this tenant already uses this name.',
    adminErrorNeedDomainToPublish: 'Add at least one allowed domain before publishing the chatbot.',
    adminSuccessBotSettingsSaved: 'Chatbot settings saved successfully.',
    adminErrorBotSettingsSaveFailed: 'Could not save chatbot settings.',

    adminCopiedEmbed: 'Embed script copied to clipboard.',
    adminCopiedIframe: 'iFrame snippet copied to clipboard.',
    adminCopiedDirectLink: 'Direct link copied to clipboard.',
    adminCopiedGeneric: 'Copied to clipboard.',

    adminCopyTooltipCopied: 'Copied',

    // --- Parsing / ZIP validation ---
    zipNoFileSelected: 'No file selected.',
    zipNotZipFile: 'The file is not a ZIP file.',
    zipInvalidFile: 'Invalid ZIP file: {error}',
    zipDuplicateTextDefinition: 'Duplicate text definition found for: {id}',
    zipMoreThanOneSup0Definition: 'More than one text definition found for the SUP0 node.',
    zipInvalidFilePath: 'Invalid file path: {path}',
    zipNoValidFileType: 'File "{file}" has no valid file type.',

    drawioXmlParserError: 'Draw.io file error: XML Parser Error',
    drawioRootNotFound: 'Draw.io file error: mxGraphModel/root not found',
    drawioMalformed: 'Draw.io file error: {error}',
    drawioStartQuestionCount: 'There must be exactly 1 start question, found: {count}',
    drawioQuestionNoAnswerPaths: 'Question "{id}" has no answer paths.',
    drawioAnswerCellNotFound: 'Answer cell not found for question "{id}".',
    drawioAnswerLeadsNowhere: 'Answer "{answer}" of question "{id}" leads nowhere.',
    drawioAnswerMultipleExits: 'Answer "{answer}" of question "{id}" has multiple ambiguous exits.',
    drawioAnswerInvalidTarget: 'Answer "{answer}" of question "{id}" does not lead to a valid target.',
    drawioPromptNoConnectives: 'Prompt "{id}" has no connective paths.',
    drawioConnectiveNoTarget: 'Connective "{text}" has no target.',
    drawioConnectiveTargetNotFound: 'Connective target not found for "{text}".',
    drawioConnectiveMustLead: 'Connective "{text}" must lead to a question or a prompt.',

    saved: 'Saved',
    languageOptionGerman: 'German',
    languageOptionEnglish: 'English',
    promptLabel: 'Prompt',
    previewLogoAlt: 'Chatbot logo',
    previewBotAlt: 'Bot preview',
    livePreview: 'Live Preview',
    previewAssistantStyle: 'Premium assistant style',
    previewAssistantMessage: 'Hello! I am ready to assist with a cleaner, more polished conversation experience.',
    activePalette: 'Active palette',
    wallpaperLabel: 'Wallpaper',
    wallpaperSectionTitle: 'Chat background wallpaper',
    wallpaperSectionDescription: 'Choose one of the fixed presets for the chat area.',
    authRequiredAgain: 'You are not authenticated yet. Please log in again.',
    errorUploadGeneric: 'Error during upload.',
    drawioClearSuccess: 'Draw.io database cleared successfully.',
    drawioClearFailed: 'Failed to clear database.',
    drawioClearError: 'Error clearing database.',
    drawioMissingUploadContext: 'Missing chatbot context for upload.',
    drawioCurrentDatabaseTitle: 'Current Draw.io Database',
    drawioCurrentDatabaseCount: '{count} node(s) currently indexed.',
    clearAll: 'Clear All',
    clearing: 'Clearing...',
    drawioValidationFailed: 'Validation failed. Please fix errors below.',
    drawioWarningTitle: 'Draw.io note',
    drawioWarningBody: 'The ZIP can still be uploaded. In this case, media and text files are stored, while the invalid Draw.io structure is skipped.',
    kbDeleteSuccess: 'Document removed.',
    kbDeleteFailed: 'Failed to remove document.',
    kbStoredDocumentsTitle: 'Stored documents',
    kbStoredDocumentsDescription: 'Overview of all knowledge-base files currently saved for this chatbot.',
    refresh: 'Refresh',
    refreshing: 'Refreshing…',
    kbLoadingDocuments: 'Loading stored documents…',
    kbNoDocuments: 'No documents are stored yet. Upload a file above to add it to the knowledge base.',
    kbUnnamedDocument: 'Unnamed document',
    kbUnknownType: 'Unknown type',
    kbChunkCount: '{count} chunks',
    kbUpdatedAt: 'Updated {date}',
    kbStatusReady: 'Ready',
    kbStatusProcessing: 'Processing',
    kbStatusFailed: 'Failed',
    kbStatusUnknown: 'Unknown',
    systemPromptDescription: 'Control the assistant behavior, tone, and system logic in a cleaner editing workspace with a more balanced width.',
    promptStatusUnsaved: 'You have unsaved prompt changes for this chatbot.',
    promptStatusSaved: 'Your latest saved prompt is already loaded for this chatbot.',
    noSavedPromptHistory: 'No saved prompt history was found for this chatbot yet.',
    modelUpdatedTo: 'Model updated to: {model}',
    adminErrorNoChatbotReturnedCreate: 'No chatbot was returned from create.',
    adminErrorNoChatbotReturnedUpdate: 'No chatbot was returned from update.',
    customizationStatusUnsaved: 'You have unsaved customization changes. Save them to apply the new style to this chatbot.',
    customizationStatusSaved: 'No unsaved customization changes right now.',
  },
};